import { useTranslate } from "@pankod/refine-core";

import { Tag } from "@pankod/refine-antd";

type ConnectionStatusProps = {
    status: "connected" | "Disconnected" | "Overdue";
};

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ status }) => {
    const t = useTranslate();
    let color;

    switch (status) {
        case "connected":
            color = "green";
            break;
        case "Disconnected":
            color = "red";
            break;
        case "Overdue":
            color = "red";
            break;
    }

    return <Tag color={color}>{t(`enum.connectionStatuses.${status}`)}</Tag>;
};
